module.exports = __webpack_public_path__ + "static/media/background-2.12787c92.png";